import React from "react";

function AddAgentStaff() {
  return <div>AddAgentStaff</div>;
}

export default AddAgentStaff;
